export class JobProgressStepRestoreWorkerData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workerIndex",
            "baseName": "workerIndex",
            "type": "number",
            "format": ""
        },
        {
            "name": "nodeName",
            "baseName": "nodeName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepRestoreWorkerData.attributeTypeMap;
    }
    constructor() {
    }
}
